export const photoFileNames: string[] = [];

export function toPublicPhotoPath(fileName: string): string {
  return `/photos/${encodeURIComponent(fileName)}`;
}

export async function loadPhotoIndex(): Promise<string[]> {
  try {
    const res = await fetch('/photos/index.json', { cache: 'no-store' });
    if (!res.ok) return [];
    const names: string[] = await res.json();
    return names;
  } catch {
    return [];
  }
}


